import classNames from "classnames";
import React from "react";
import { connect } from "react-redux";
import { t } from "ttag";

import { TStateMapper } from "../../reducers.interfaces";
import { Step } from "../constants";
import { IReduxFormState } from "../reducers.interfaces";

interface IOwnProps {
    onEdit?: (event?: React.MouseEvent<HTMLElement>) => void;
}

interface IReduxProps {
    form: IReduxFormState;
    showSummary: boolean;
}

interface IDispatchProps {}

interface IProps extends IOwnProps, IReduxProps, IDispatchProps {}

interface IState {}

// TODO(ssr, LEVEL 2 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 2/10 due to simple render-only component with Redux connect.
class BillingAddressSummaryComponent extends React.Component<IProps, IState> {
    render() {
        const summaryClasses = classNames({
            "checkout-step__summary": true,
            "checkout-step__summary--collapsed": !this.props.showSummary,
        });
        return (
            <div className={summaryClasses}>
                <h3 className="checkout-step__label">{t`Bill to:`}</h3>
                <div className="checkout-step__billing-address">
                    {/* TODO(i18n): Hard-coded word order assumption. Name format varies by locale. Use template with interpolation: t`${firstName} ${lastName}` or consider locale-specific name formatting */}
                    {this.props.form.billing_first_name}{" "}
                    {this.props.form.billing_last_name}
                    <br />
                    {this.props.form.billing_line1}
                    <br />
                    {this.props.form.billing_line2 ? (
                        <div>{this.props.form.billing_line2}</div>
                    ) : null}
                    {/* TODO(i18n): Hard-coded address format and punctuation (comma, spaces). Address format varies by country. Consider locale-specific address formatting or use template: t`${city}, ${state} ${postcode}` */}
                    {this.props.form.billing_line4},{" "}
                    {this.props.form.billing_state}{" "}
                    {this.props.form.billing_postcode}
                    <br />
                    {this.props.form.billing_phone_number}
                </div>
                {this.props.onEdit && (
                    <a
                        className="checkout-step__back"
                        href="#"
                        onClick={this.props.onEdit}
                    >
                        {t`Edit`}
                    </a>
                )}
            </div>
        );
    }
}

const mapStateToProps: TStateMapper<"checkout", IReduxProps, IOwnProps> = (
    rootState,
    ownProps,
) => {
    const state = rootState.checkout;
    return {
        form: state.form,
        showSummary: state.form.current_step > Step.BILLING_ADDRESS,
        ...ownProps,
    };
};

export const BillingAddressSummary = connect(mapStateToProps)(
    BillingAddressSummaryComponent,
);
